import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { CurrencyCode } from "models/enums/currency";
import { WintSalaryEnums } from "models/enums";
//#endregion
//#region components
import { SimpleAccordionTable } from "components/common";
import { useGrossSalaryChangeContext } from "../context/useGrossSalaryChangeContext";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

interface GrossSalaryChangeFloorBannerProps {
  taxType: WintSalaryEnums.ChangeGrossSalaryTaxType | undefined;
  showOneTimeTaxButton: boolean;
}

const GrossSalaryChangeFloorBanner: React.FC<GrossSalaryChangeFloorBannerProps> = ({
  taxType,
  showOneTimeTaxButton,
}) => {
  const { minimumTargetGrossSalaryAmount } = useGrossSalaryChangeContext();
  const { taxTableMinimumAmount, oneTimeTaxMinimumAmount, alreadyPaidOutNetAmount } = minimumTargetGrossSalaryAmount;

  const effectiveTaxType =
    showOneTimeTaxButton && taxType !== undefined ? taxType : WintSalaryEnums.ChangeGrossSalaryTaxType.TableTax;
  const floor =
    effectiveTaxType === WintSalaryEnums.ChangeGrossSalaryTaxType.OneTimeTax
      ? oneTimeTaxMinimumAmount
      : taxTableMinimumAmount;

  if (floor <= 0) return null;

  const integerFloor = Math.ceil(floor);
  const formattedFloor = LocalizationHelperInstance.getFormattedCurrency(integerFloor, CurrencyCode.SEK);

  const descriptionKey =
    alreadyPaidOutNetAmount > 0
      ? TranslationKeys.Salary.GrossSalaryChangeFloorBannerWithPaidNet
      : TranslationKeys.Salary.GrossSalaryChangeFloorBannerWithoutPaidNet;
  const description = LocalizationHelperInstance.getFormattedMessage(descriptionKey);

  return (
    <SimpleAccordionTable
      variant="secondary"
      items={[
        {
          title: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Salary.GrossSalaryChangeMinFloorAccordionTitle
          ),
          value: formattedFloor,
          subContent: [{ title: description }],
        },
      ]}
    />
  );
};

export default GrossSalaryChangeFloorBanner;
